/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Branchen_Kennenlernen25Inputs */

const en__field_enum_icsrm_branchen_kennenlernen25 = /** @type {(inputs: _Field_Enum_Icsrm_Branchen_Kennenlernen25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get to know other industries`)
};

const de__field_enum_icsrm_branchen_kennenlernen25 = /** @type {(inputs: _Field_Enum_Icsrm_Branchen_Kennenlernen25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branchen und Tätigkeitsfelder kennenlernen`)
};

/**
* | output |
* | --- |
* | "Get to know other industries" |
*
* @param {_Field_Enum_Icsrm_Branchen_Kennenlernen25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_branchen_kennenlernen25 = /** @type {((inputs?: _Field_Enum_Icsrm_Branchen_Kennenlernen25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Branchen_Kennenlernen25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_branchen_kennenlernen25(inputs)
	return de__field_enum_icsrm_branchen_kennenlernen25(inputs)
});
export { _field_enum_icsrm_branchen_kennenlernen25 as "_field_enum_ICSRM_BRANCHEN_KENNENLERNEN" }